/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { ConnectAndHealModal } from '../../pages/dashboard/_modals/Futurisk/ConnectAndHealModal'


type Props = {
  className: string
  title: string
  description: string
  avatar: string
  link: string | undefined
}

const ConnectAndHealLinkWidget: React.FC<Props> = ({ className, title, description, avatar, link, }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
      <div style={{ padding: 0 }}>
        <div
          className={`hoverable`}
          role="button"
          onClick={() => setModalShow(true)}
          style={{ cursor: 'pointer' }}
        >
          <img src={toAbsoluteUrl('/media/partner/seva.png')} width="100%" alt='Seva' className='card-p-5 shadow' style={{ borderRadius: 8 }} />
        </div>
        <ConnectAndHealModal show={modalShow} handleClose={() => setModalShow(false)} />
      </div>
    );


  
}

export { ConnectAndHealLinkWidget }
